/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import CashbackRepository from '../../repositories/Admin/CashbackRepository';
import { createRestSlice } from '../../utils/RestSlice';
import DatePresenter from '../../presenters/DatePresenter';

const cashbacksRestSlice = createRestSlice({
  resource: 'cashback',
  repository: CashbackRepository,
  slices: ['loadCashbacks', 'createCashback', 'deleteCashback'],
});

const initialState = {
  ...cashbacksRestSlice.initialState,
  afterDate: DatePresenter.oneMonthAgo(),
  beforeDate: DatePresenter.today(),
};

const cashbacksSlice = createSlice({
  name: 'cashbacks',
  initialState,
  reducers: {
    ...cashbacksRestSlice.reducers,
    changeStartdate: (state, action) => {
      state.afterDate = action.payload;
    },
    changeEndate: (state, action) => {
      state.beforeDate = action.payload;
    },
  },
});
export const { changeStartdate, changeEndate } = cashbacksSlice.actions;
export const selectStartdate = (state) => state.admin.CashbacksSlice.afterDate;
export const selectEndate = (state) => state.admin.CashbacksSlice.beforeDate;
export default cashbacksSlice.reducer;

export const cashbacksRestHooks = cashbacksRestSlice.hooks(cashbacksSlice, [
  'admin',
  'CashbacksSlice',
]);
